export default __webpack_public_path__ + "static/media/mission-content-img.e16d8cfe.png";